import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import styles from './index.module.scss'

interface LoadingProps {
  isLoading: boolean
  children: any
}

export function Loading({ isLoading, children }: LoadingProps) {
  return (
    <Spin
      spinning={isLoading}
      className={styles.loadingRoot}
      indicator={<LoadingOutlined className={styles.spin} />}
    >
      {children}
    </Spin>
  )
}
